
import { AnyAction, ThunkAction } from "@reduxjs/toolkit";
import WaterfallDetailsService from "../../services/WaterfalDetailsService";
import { RootState } from "../store";
import { WaterfalldetailsModel } from "../../models/WaterfallDetailsModel";
import WaterfallDetailsSlice from "../slices/WaterfallDetailsSlice";

export const WaterfallDetailsActions = WaterfallDetailsSlice.actions

export const fetchWaterFallDetails = (
    userId: number,
): ThunkAction<void, RootState, unknown, AnyAction> => {
    return async (dispatch) => {
        dispatch(WaterfallDetailsActions.setWaterFallDetailsFetching(true))
        const response: WaterfalldetailsModel[] = await WaterfallDetailsService.getWaterfallDetails(userId);
        dispatch(WaterfallDetailsActions.setWaterFallDetails(response));
        dispatch(WaterfallDetailsActions.setWaterFallDetailsFetching(false))
    }
}


